import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import { IndustryBuilderGuard } from "@/components/auth/IndustryBuilderGuard";
import PestControlProposalBuilder from "@/pages/PestControlProposalBuilder";
export const Route = createFileRoute("/pest-control-builder")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><IndustryBuilderGuard industry="pest-control"><PestControlProposalBuilder /></IndustryBuilderGuard></ProtectedRoute>) });
